import React from 'react';
import { motion } from 'framer-motion';
import { Award, MapPin, History } from 'lucide-react';
export function Legacy() {
  return <section id="legacy" className="py-12 bg-white overflow-hidden" data-id="element-244">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-245">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-246">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-247">
            <div className="aspect-[4/5] bg-slate-100 rounded-sm overflow-hidden relative group" data-id="element-248">
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=800" alt="Founder Portrait" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-249" />
              <div className="absolute inset-0 bg-federal-blue/10 mix-blend-multiply" data-id="element-250" />
              <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-federal-blue to-transparent text-white" data-id="element-251">
                <p className="text-xs font-bold tracking-[0.3em] uppercase mb-1 opacity-80" data-id="element-252">
                  Founder & CEO
                </p>
                <p className="text-2xl font-black uppercase tracking-tight" data-id="element-253">
                  15+ Years of Federal Excellence
                </p>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 border-t-4 border-r-4 border-muted-gold z-0" data-id="element-254" />
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border-b-4 border-l-4 border-federal-blue z-0" data-id="element-255" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-256">
            <h2 className="text-federal-blue text-sm font-black tracking-[0.2em] uppercase mb-6 flex items-center gap-2" data-id="element-257">
              <History className="w-4 h-4" data-id="element-258" />
              The Founders' 15-Year Legacy
            </h2>
            <h3 className="text-4xl md:text-5xl font-black text-tech-slate mb-8 leading-[1.1]" data-id="element-259">
              Bridging Private Innovation with <br data-id="element-260" />
              <span className="text-federal-blue" data-id="element-261">Federal Rigor.</span>
            </h3>

            <div className="space-y-6 text-tech-slate leading-relaxed text-lg opacity-90" data-id="element-262">
              <p data-id="element-263">
                For over a decade and a half, Codes & Cogs has stood at the
                intersection of cutting-edge technology and stringent government
                standards. We don't just build software; we engineer
                mission-critical infrastructure that adheres to the highest NIST
                and HIPAA requirements.
              </p>
              <p data-id="element-264">
                Our roots are deep in the{' '}
                <span className="font-bold text-federal-blue underline decoration-muted-gold decoration-2 underline-offset-4" data-id="element-265">
                  North Carolina and Maryland
                </span>{' '}
                corridor. We understand the unique needs of agencies local to
                the Baltimore-Washington metropolitan area and the growing tech
                hubs of Charlotte and Raleigh.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-8 mt-12" data-id="element-266">
              <div className="flex gap-4" data-id="element-267">
                <div className="flex-shrink-0 w-12 h-12 bg-muted-gold/10 flex items-center justify-center rounded-full" data-id="element-268">
                  <Award className="w-6 h-6 text-muted-gold" data-id="element-269" />
                </div>
                <div data-id="element-270">
                  <h4 className="font-bold text-federal-blue" data-id="element-271">
                    WOSB Certified
                  </h4>
                  <p className="text-xs text-tech-slate opacity-70 uppercase tracking-wider font-bold" data-id="element-272">
                    Woman-Owned Small Business
                  </p>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-273">
                <div className="flex-shrink-0 w-12 h-12 bg-federal-blue/10 flex items-center justify-center rounded-full" data-id="element-274">
                  <MapPin className="w-6 h-6 text-federal-blue" data-id="element-275" />
                </div>
                <div data-id="element-276">
                  <h4 className="font-bold text-federal-blue" data-id="element-277">
                    Local Presence
                  </h4>
                  <p className="text-xs text-tech-slate opacity-70 uppercase tracking-wider font-bold" data-id="element-278">
                    NC & MD Strategic Hubs
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}